import classnames from 'classnames'
import * as React from 'react'

import {usePermission} from '../../../hooks/usePermission'
import {Permission, ROOT_PROJECT_ID} from '../../../types'
import {noop} from '../../../utils/empty'
import IconButton from '../IconButton/IconButton'

import type {Props} from './FavoriteStar.types'

import styles from './FavoriteStar.css'

function FavoriteStar({
  className,
  emptyClassName = '',
  iconWrapperClassName,
  isStarred,
  showEmpty = true,
  onStar = noop,
  onMouseEnter,
  onMouseLeave,
  title,
}: Props) {
  const isStarrable = usePermission(Permission.CHANGE_OWN_PROFILE, ROOT_PROJECT_ID)
  const classes = classnames(className, emptyClassName, {
    [styles.invisible]: !showEmpty && !isStarred,
  })
  const iconWrapperClasses = classnames(iconWrapperClassName, {
    [styles.starred]: isStarred,
  })

  if (!isStarrable) {
    return null
  }

  const defaultTitle = isStarred ? 'Remove from favorites' : 'Add to favorites'
  return (
    <IconButton
      onClick={onStar}
      icon={isStarred ? 'star-filled' : 'star-empty'}
      className={classes}
      iconWrapperClassName={iconWrapperClasses}
      title={title ?? defaultTitle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-test="overview-star"
      aria-label={defaultTitle}
    />
  )
}

export default FavoriteStar
